module.exports = __webpack_public_path__ + "img/paper1.340043b6.png";